import React, { useState, useEffect, useCallback, useContext } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  CircularProgress,
  Alert,
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  TablePagination,
  FormControl,
  InputLabel,
  Select
} from '@mui/material';
import {
  Download as DownloadIcon,
  Refresh as RefreshIcon,
  FilterList as FilterIcon,
  Clear as ClearIcon,
  Gavel as GavelIcon,
  CheckCircle,
  Schedule,
  Assignment,
  Visibility
} from '@mui/icons-material';
import ExcelJS from 'exceljs';
import injupemplogo from './injupemplogo.png';
import { useNavigate } from 'react-router-dom';
import { ContextSession } from "../../services/ContextSession";
const ReporteriaDemandasLegales = () => {
  const navigate = useNavigate();
  // Estados para los datos
  const [demandas, setDemandas] = useState([]);
  const [procuradores, setProcuradores] = useState([]);
  const [filteredDemandas, setFilteredDemandas] = useState([]);
  
  // Estados para filtros
  const [filtros, setFiltros] = useState({
    procurador: '',
    estado: '',
    fechaInicio: '',
    fechaFin: '',
    tipoDemanda: '',
    juzgado: '',
    naturaleza: '',
    tipoDemandante: ''
  });
  
  // Estados para UI
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState('');
  const [dialogFiltros, setDialogFiltros] = useState(false);

  // Estados para paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

   let sessi = useContext(ContextSession);
  // Mapeo de opciones
  const mapeos = {
    naturaleza: {
      1: 'A Favor',
      2: 'En Contra'
    },
    tipoDemandante: {
      1: 'Persona Natural',
      2: 'Persona Jurídica',
      3: 'Proveedor',
      4: 'Colaborador',
      5: 'Otros'
    },
    tipoDemanda: {
      1: 'Daños y Perjuicios',
      2: 'Ejecución de Garantías',
      3: 'Ejecución de Pagos',
      4: 'Ejecución de Títulos',
      5: 'Ejecutiva',
      6: 'Extra Contractual',
      7: 'Laboral',
      8: 'Monitorio',
      9: 'Nulidad de Instrumentos',
      10: 'Responsabilidad Contractual',
      11: 'Otros'
    },
    juzgado: {
      1: 'Juzgado Civil',
      2: 'Juzgado Primero de Letras Departamental',
      3: 'Juzgado Primero de Letras Seccional',
      4: 'Ministerio Público',
      5: 'Otros'
    },

    resultadoprimerainstancia: {
      1: 'Favorable',
      2: 'Desfavorable',
      3: 'No Aplica',
      
    },
    
    resultadosegundainstancia: {
      1: 'Favorable', 
      2: 'Desfavorable',
      3: 'No Aplica',
    },
    
    riesgocredito: {
      1: 'Sí',
      2: 'No'
    },

    moneda: {
      1: 'Lempiras (HNL)',
      2: 'Dólares (USD)',
      3: 'Euros (EUR)'
    },
    resultadoCierre: {
      1: 'Favorable',
      2: 'Desfavorable',
      3: 'Conciliación',
      4: 'Proceso desistido o abandono de proceso',
      5: 'Otros'
    }
  };

  // Cargar procuradores
  useEffect(() => {
    const fetchProcuradores = async () => {
      try {
        const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/auth/oficialesLegal/');
        if (response.ok) {
          const data = await response.json();
          setProcuradores(data);
        }
      } catch (error) {
        console.error('Error fetching procuradores:', error);
      }
    };

    fetchProcuradores();
  }, []);

  // Cargar demandas
  useEffect(() => {
    const fetchDemandas = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/tramite/listar/');
        if (response.ok) {
          const data = await response.json();
          
          // Ordenar del más nuevo al más antiguo
          const sortedData = data.sort((a, b) => {
            return new Date(b.fechacreacion) - new Date(a.fechacreacion);
          });
          
          setDemandas(sortedData);
          setFilteredDemandas(sortedData);
        } else {
          console.error('Error fetching demandas data');
          setError('Error al cargar las demandas legales');
        }
      } catch (error) {
        console.error('Error:', error);
        setError('Error de conexión al cargar las demandas legales');
      } finally {
        setLoading(false);
      }
    };

    fetchDemandas();
  }, []);

  // Función para obtener información del procurador
const getInfoProcurador = (procuradorAsignado) => {
  if (!procuradorAsignado) return { nombre: 'No asignado', email: '' };
  
  // Si es un número (ID), buscar en la lista de procuradores
  const id = Number(procuradorAsignado);
  if (!isNaN(id)) {
    const procurador = procuradores.find(p => p.id === id);
    if (procurador) {
      return {
        nombre: procurador.nombre || `Procurador #${id}`,
        email: procurador.email || '',
        departamento: procurador.departamento || ''
      };
    }
  }
  
  // Si es un string (nombre), buscar por nombre
  const procurador = procuradores.find(p => 
    p.nombre && p.nombre.trim().toLowerCase() === procuradorAsignado.toString().trim().toLowerCase()
  );
  
  if (procurador) {
    return {
      nombre: procurador.nombre,
      email: procurador.email || '',
      departamento: procurador.departamento || ''
    };
  }
  
  // Si no se encuentra, devolver el valor original
  return { 
    nombre: procuradorAsignado.toString(), 
    email: '',
    departamento: ''
  };
};

  // Formatear fecha
  const formatearFecha = (fechaISO) => {
    if (!fechaISO) return 'N/A';
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  // Formatear valor monetario
  const formatearMoneda = (valor) => {
    if (!valor || isNaN(parseFloat(valor))) return 'L. 0.00';
    return `L. ${parseFloat(valor).toLocaleString('es-HN', { minimumFractionDigits: 2 })}`;
  };

  // Obtener color según estado
  const getColorEstado = (estado) => {
    const estadoLower = estado?.toLowerCase();
    switch (estadoLower) {
      case 'cerrado': return 'warning';
      case 'en proceso': return 'primary';
      case 'creada': return 'success';
      default: return 'default';
    }
  };

  // Obtener texto mapeado
  const getTextoMapeado = (valor, tipo) => {
    return mapeos[tipo]?.[valor] || `No definido (${valor})`;
  };

  // Aplicar filtros
  const aplicarFiltros = () => {
    let filtered = [...demandas];

    // Filtro por rango de fechas
    if (filtros.fechaInicio) {
      filtered = filtered.filter(item => {
        const fechaCreacion = item.fechacreacion;
        if (!fechaCreacion) return false;
        const fechaItem = new Date(fechaCreacion).toISOString().split('T')[0];
        return fechaItem >= filtros.fechaInicio;
      });
    }

    if (filtros.fechaFin) {
      filtered = filtered.filter(item => {
        const fechaCreacion = item.fechacreacion;
        if (!fechaCreacion) return false;
        const fechaItem = new Date(fechaCreacion).toISOString().split('T')[0];
        return fechaItem <= filtros.fechaFin;
      });
    }

      // Filtro por procurador
    if (filtros.procurador) {
      filtered = filtered.filter(item => {
        const procuradorAsignado = item.procuradorasignado;
        if (!procuradorAsignado) return false;
        
        // Buscar tanto por ID como por nombre
        const infoProcurador = getInfoProcurador(procuradorAsignado);
        return infoProcurador.nombre.toLowerCase().includes(filtros.procurador.toLowerCase()) ||
              procuradorAsignado.toString() === filtros.procurador;
      });
}

    // Filtro por estado
    if (filtros.estado) {
      filtered = filtered.filter(item => item.estado === filtros.estado);
    }

    // Filtro por tipo de demanda
    if (filtros.tipoDemanda) {
      filtered = filtered.filter(item => {
        const tipoId = item.tipodemanda;
        return tipoId && tipoId.toString() === filtros.tipoDemanda;
      });
    }

    // Filtro por juzgado
    if (filtros.juzgado) {
      filtered = filtered.filter(item => {
        const juzgadoId = item.juzgado;
        return juzgadoId && juzgadoId.toString() === filtros.juzgado;
      });
    }

    // Filtro por naturaleza
    if (filtros.naturaleza) {
      filtered = filtered.filter(item => {
        const naturalezaId = item.naturaleza;
        return naturalezaId && naturalezaId.toString() === filtros.naturaleza;
      });
    }

    // Filtro por tipo de demandante
    if (filtros.tipoDemandante) {
      filtered = filtered.filter(item => {
        const tipoDemandanteId = item.tipodemandante;
        return tipoDemandanteId && tipoDemandanteId.toString() === filtros.tipoDemandante;
      });
    }

    // Mantener el orden por fecha descendente
    const filteredAndSorted = filtered.sort((a, b) => new Date(b.fechacreacion) - new Date(a.fechacreacion));
    setFilteredDemandas(filteredAndSorted);
    setPage(0);
    setDialogFiltros(false);
  };

  // Limpiar filtros
  const limpiarFiltros = () => {
    setFiltros({
      procurador: '',
      estado: '',
      fechaInicio: '',
      fechaFin: '',
      tipoDemanda: '',
      juzgado: '',
      naturaleza: '',
      tipoDemandante: ''
    });
    const demandasOrdenadas = [...demandas].sort((a, b) => new Date(b.fechacreacion) - new Date(a.fechacreacion));
    setFilteredDemandas(demandasOrdenadas);
    setPage(0);
    setDialogFiltros(false);
  };

  // Obtener opciones únicas para los filtros
  const estadosUnicos = [...new Set(demandas
    .map(item => item.estado)
    .filter(estado => estado != null)
  )];

  const tiposDemandaUnicos = [...new Set(demandas
    .map(item => item.tipodemanda)
    .filter(tipo => tipo != null)
  )];

  const juzgadosUnicos = [...new Set(demandas
    .map(item => item.juzgado)
    .filter(juzgado => juzgado != null)
  )];

  const naturalezasUnicas = [...new Set(demandas
    .map(item => item.naturaleza)
    .filter(naturaleza => naturaleza != null)
  )];

  const tiposDemandanteUnicos = [...new Set(demandas
    .map(item => item.tipodemandante)
    .filter(tipo => tipo != null)
  )];

 // Obtener procuradores únicos para el filtro
const procuradoresUnicos = [...new Set(demandas
  .map(item => item.procuradorasignado)
  .filter(id => id != null)
)].map(procuradorId => {
  const infoProcurador = getInfoProcurador(procuradorId);
  return {
    id: procuradorId,
    nombre: infoProcurador.nombre
  };
});
  // Obtener estadísticas
 const estadisticas = {
  total: filteredDemandas.length,
  creadas: filteredDemandas.filter(d => d.estado?.toLowerCase() === 'creada').length,
  en_proceso: filteredDemandas.filter(d => d.estado?.toLowerCase() === 'en proceso' || d.estado?.toLowerCase() === 'en_proceso').length,
  cerradas: filteredDemandas.filter(d => d.estado?.toLowerCase() === 'cerrado').length,
};


  // Funciones de paginación
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Obtener datos paginados
  const demandasPaginadas = filteredDemandas.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // Función para convertir imagen a Base64
  const imageToBase64 = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = reject;
      img.src = imageUrl;
    });
  };

const exportarAExcel = async () => {
  setExporting(true);

  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Reporte Demandas Legales INJUPEMP');

    let currentRow = 1;
    worksheet.views = [
      { state: 'frozen', ySplit: 5, showGridLines: false } 
    ];

    // LOGO 
    try {
      const logoBase64 = await imageToBase64(injupemplogo);
      const base64Data = logoBase64.replace(/^data:image\/png;base64,/, '');

      const imageId = workbook.addImage({
        base64: base64Data,
        extension: 'png',
      });

      worksheet.addImage(imageId, {
        tl: { col: 1, row: 1 },
        br: { col: 4, row: 4 },
      });

    } catch (error) {
      console.warn("No se pudo cargar el logo:", error);
    }

    // TÍTULO PRINCIPAL 
    const titleCell = worksheet.getCell('A4');
    titleCell.value = "REPORTE DE DEMANDAS";
    titleCell.font = { 
      bold: true, 
      size: 16,
      name: 'Arial'
    };
    titleCell.alignment = { horizontal: "center" };
    titleCell.fill = { type: 'pattern', pattern: 'none' };
    titleCell.border = {
      top: { style: 'none' },
      left: { style: 'none' },
      bottom: { style: 'none' },
      right: { style: 'none' }
    };
    worksheet.mergeCells('A4:M4');

    // Fecha de generación
    const fechaCell = worksheet.getCell('B5');
    fechaCell.value = `Fecha: ${new Date().toLocaleString('es-ES')}`;
    fechaCell.font = { 
      name: 'Arial',
      size: 9,
      bold: true
    };
    fechaCell.fill = { type: 'pattern', pattern: 'none' };
    fechaCell.border = {
      top: { style: 'none' },
      left: { style: 'none' },
      bottom: { style: 'none' },
      right: { style: 'none' }
    };

    // Período del reporte
    const periodoCell = worksheet.getCell('D5');
    periodoCell.value = `Período: ${filtros.fechaInicio || 'Inicio'} - ${filtros.fechaFin || 'Fin'}`;
    periodoCell.font = { 
      name: 'Arial',
      size: 9,
      bold: true
    };
    periodoCell.fill = { type: 'pattern', pattern: 'none' };
    periodoCell.border = {
      top: { style: 'none' },
      left: { style: 'none' },
      bottom: { style: 'none' },
      right: { style: 'none' }
    };

    // ESPACIO ENTRE TÍTULO Y TABLA
    const spacerCell = worksheet.getCell('A6');
    spacerCell.fill = { type: 'pattern', pattern: 'none' };
    spacerCell.border = {
      top: { style: 'none' },
      left: { style: 'none' },
      bottom: { style: 'none' },
      right: { style: 'none' }
    };
    
    currentRow = 6;

    // ENCABEZADOS DE TABLA 
    const encabezados = [
      'ID', 'N° Demanda', 'N° Expediente', 'Fecha Presentacion', 'Naturaleza', 'Demandante', 'Demandado',
      'Tipo de demandante', 'Estado', 'Observaciones', 'Procurador','Tipo Demanda', 'Motivo', 'Juzgado',
      'Fecha Creación', 'Fecha Actuación', 'Fecha Max Contestación', 'Acción de la Institución', 
      'Tipo de moneda', 'Tipo de Cambio', 'Monto Estimación', 'Cuenta Estimación', 'Cuenta Provisión', 
      'Cuenta Gastos', 'Riesgo de credito', 'Monto gastos legales', 'Monto Demandado', 'Monto Provisión',
      'Resultado 1 instancia', 'Resultado 2 instancia', 'Valor Definitivo Conciliado', 'Cuenta Valor Definitivo',
      'Resultado de la Demanda', 'Descripción Cierre'
    ];

    const headerRow = worksheet.getRow(currentRow);

    encabezados.forEach((header, index) => {
      const cell = headerRow.getCell(index + 1);
      cell.value = header;
      cell.font = { 
        bold: true, 
        color: { argb: 'FFFFFFFF' }, 
        name: 'Arial',
        size: 10
      };
      cell.alignment = { 
        horizontal: 'center', 
        vertical: 'middle',
        wrapText: true
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF6BC5D0' }
      };
      cell.border = {
        top: { style: 'thin', color: { argb: 'FF6BC5D0' } },
        left: { style: 'thin', color: { argb: 'FF6BC5D0' } },
        bottom: { style: 'thin', color: { argb: 'FF6BC5D0' } },
        right: { style: 'thin', color: { argb: 'FF6BC5D0' } }
      };
    });

    headerRow.height = 25;
    currentRow++;

    // FUNCIÓN CORREGIDA PARA MANEJAR FECHAS
    const formatearFechaExcel = (fechaISO) => {
      if (!fechaISO) return 'N/A';
      
      try {
        // Crear fecha y ajustar por zona horaria para evitar el día extra
        const fecha = new Date(fechaISO);
        // Ajustar a la zona horaria local
        const fechaAjustada = new Date(fecha.getTime() + (fecha.getTimezoneOffset() * 60000));
        return fechaAjustada;
      } catch (error) {
        console.warn('Error formateando fecha:', fechaISO, error);
        return 'N/A';
      }
    };

    // FUNCIÓN PARA MANEJAR VALORES NULL EN MAPEOS
    const getTextoMapeado = (valor, tipo) => {
      if (valor === null || valor === undefined || valor === '') {
        return 'N/A';
      }
      return mapeos[tipo]?.[valor] || `No definido (${valor})`;
    };

    // DATOS DE LA TABLA CON CORRECCIONES
    const datosExcel = filteredDemandas.map(item => {
      const infoProcurador = getInfoProcurador(item.procuradorasignado);

      return {
        'ID': item.tramiteid,
        'N° Demanda': item.numerodemanda || 'N/A',
        'N° Expediente': item.numeroexpediente || 'N/A',
        'Fecha Presentacion': formatearFechaExcel(item.fechapresentacion),
        'Naturaleza': getTextoMapeado(item.naturaleza, 'naturaleza'),
        'Demandante': item.nombredemandante || 'N/A',
        'Demandado': item.nombredemandado || 'N/A',
        'Tipo de demandante': getTextoMapeado(item.tipodemandante, 'tipoDemandante'),
        'Estado': item.estado || 'N/A',
        'Observaciones': item.observaciones || 'N/A',
        'Procurador': infoProcurador.nombre,
        'Tipo Demanda': getTextoMapeado(item.tipodemanda, 'tipoDemanda'),
        'Motivo': item.motivodemanda || 'N/A',
        'Juzgado': getTextoMapeado(item.juzgado, 'juzgado'),
        'Fecha Creación': formatearFechaExcel(item.fechacreacion),
        'Fecha Actuación': formatearFechaExcel(item.fechaactuacion),
        'Fecha Max Contestación': formatearFechaExcel(item.fechamaximacontestacion),
        'Acción de la Institución': item.accioninstitucion || 'N/A',
        'Tipo de moneda': getTextoMapeado(item.moneda, 'moneda'),
        'Tipo de Cambio': item.tipocambio || 'N/A',
        'Monto Estimación': item.montoestimacion || '0.00',
        'Cuenta Estimación': item.cuentaestimacion || 'N/A',
        'Cuenta Provisión': item.cuentaprovision || 'N/A',
        'Cuenta Gastos': item.cuentagastos || 'N/A',
        'Riesgo de credito': getTextoMapeado(item.riesgocredito, 'riesgocredito'),
        'Monto gastos legales': item.montogastoslegales || '0.00',
        'Monto Demandado': item.montodemandado || '0.00',
        'Monto Provisión': item.montoprovision || '0.00',
        'Resultado 1 instancia': getTextoMapeado(item.resultadoprimerainstancia, 'resultadoprimerainstancia'),
        'Resultado 2 instancia': getTextoMapeado(item.resultadosegundainstancia, 'resultadosegundainstancia'),
        'Valor Definitivo Conciliado': item.valordefinitivoconciliado || '0.00',
        'Cuenta Valor Definitivo': item.cuentavalordefinitivo || 'N/A',
        'Resultado de la Demanda': getTextoMapeado(item.resultadocierre, 'resultadoCierre'),
        'Descripción Cierre': item.descripcioncierre || 'N/A'
      };
    });

    // AGREGAR DATOS A LA HOJA
    datosExcel.forEach((item) => {
      const row = worksheet.getRow(currentRow);

      Object.values(item).forEach((value, colIndex) => {
        const cell = row.getCell(colIndex + 1);
        cell.value = value;
        cell.font = {
          name: 'Arial',
          size: 9,
          color: { argb: 'FF000000' }
        };

        // Formatear fechas
        if (value instanceof Date && value !== 'N/A') {
          cell.numFmt = 'dd/mm/yyyy';
          cell.alignment = { horizontal: 'center' };
        }

        // Formatear montos monetarios
        const columnasMonetarias = [20, 25, 26, 27, 29]; // Índices de columnas monetarias
        if (columnasMonetarias.includes(colIndex) && value !== 'N/A' && !isNaN(parseFloat(value))) {
          cell.value = parseFloat(value);
          cell.numFmt = '#,##0.00';
          cell.alignment = { horizontal: 'right' };
        }

        // Bordes azules para las celdas de datos
        cell.border = {
          top: { style: 'thin', color: { argb: '#19438C' } },
          left: { style: 'thin', color: { argb: '#19438C' } },
          bottom: { style: 'thin', color: { argb: '#19438C' } },
          right: { style: 'thin', color: { argb: '#19438C' } }
        };
      });

      row.height = 20;
      currentRow++;
    });

    // ANCHOS DE COLUMNA 
    const columnWidths = [8, 12, 15, 15, 12, 18, 18, 15, 12, 20, 15, 12, 15, 20, 12, 12, 12, 12, 15, 20, 12, 12, 15, 15, 15, 12, 15, 15, 15, 15, 18, 18, 20, 20];
    columnWidths.forEach((w, i) => {
      worksheet.getColumn(i + 1).width = w;
    });

    // DESCARGA DEL ARCHIVO
    const fecha = new Date().toISOString().split('T')[0];
    const nombreArchivo = `Reporte_Demandas_Legales_INJUPEMP_${fecha}.xlsx`;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nombreArchivo;
    link.click();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error('Error al exportar:', error);
    setError('Error al exportar el reporte: ' + error.message);
  } finally {
    setExporting(false);
  }
};

  // Componente de tarjeta de estadísticas
  const TarjetaEstadistica = ({ titulo, valor, icono, color, subtitulo }) => (
    <Card sx={{ 
      bgcolor: color, 
      color: 'white', 
      textAlign: 'center',
      transition: 'transform 0.2s, box-shadow 0.2s',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: 4
      }
    }}>
      <CardContent>
        {icono}
        <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', my: 1 }}>
          {valor}
        </Typography>
        <Typography variant="h6" component="div">
          {titulo}
        </Typography>
        {subtitulo && (
          <Typography variant="body2" sx={{ opacity: 0.9, mt: 1 }}>
            {subtitulo}
          </Typography>
        )}
      </CardContent>
    </Card>
  );

  // Función para ver detalles (puedes implementar la navegación)
  const verDetalles = useCallback((demanda) => {
      sessi.setVariable("demandaID", demanda.tramiteid);
      navigate(`/Legal/AccionesDemanda`);
    }, [navigate, sessi]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ ml: 2 }}>
          Cargando demandas legales...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      {/* Header */}
      <AppBar position="static" color="primary" elevation={2}>
        <Toolbar>
          <GavelIcon sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Reportería de Demandas Legales
          </Typography>
          <Tooltip title="Recargar datos">
            <IconButton color="inherit" onClick={() => window.location.reload()} disabled={loading}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>

      {error && (
        <Alert severity="error" sx={{ mt: 2 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {/* Estadísticas */}
      <Grid container spacing={3} sx={{ mt: 1, mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <TarjetaEstadistica
            titulo="Total Demandas"
            valor={estadisticas.total}
            icono={<Assignment sx={{ fontSize: 40, opacity: 0.9 }} />}
            color="info.main"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TarjetaEstadistica
            titulo="Creadas"
            valor={estadisticas.creadas}
            icono={<Schedule sx={{ fontSize: 40, opacity: 0.9 }} />}
            color="warning.main"
          />
        </Grid>
         <Grid item xs={12} sm={6} md={3}>
          <TarjetaEstadistica
            titulo="En proceso"
            valor={estadisticas.en_proceso}
            icono={<Schedule sx={{ fontSize: 40, opacity: 0.9 }} />}
            color="primary.main"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TarjetaEstadistica
            titulo="Cerradas"
            valor={estadisticas.cerradas}
            icono={<CheckCircle sx={{ fontSize: 40, opacity: 0.9 }} />}
            color="success.main"
          />
        </Grid>
      </Grid>

      {/* Barra de acciones */}
      <Card sx={{ mb: 3, boxShadow: 2 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={8}>
              <Typography variant="h6" color="textSecondary" gutterBottom>
                Resumen de Resultados
              </Typography>
              <Typography variant="body1" color="textSecondary">
                {filteredDemandas.length} demandas encontradas • 
                Activas: {estadisticas.activas} • 
                Cerradas: {estadisticas.cerrado} • 
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
              <Button
                variant="outlined"
                startIcon={<FilterIcon />}
                onClick={() => setDialogFiltros(true)}
                disabled={demandas.length === 0}
              >
                Filtros
              </Button>
              <Button
                variant="contained"
                color="success"
                startIcon={<DownloadIcon />}
                onClick={exportarAExcel}
                disabled={exporting || filteredDemandas.length === 0}
                sx={{ minWidth: 160 }}
              >
                {exporting ? (
                  <>
                    <CircularProgress size={16} sx={{ mr: 1 }} />
                    Exportando...
                  </>
                ) : (
                  'Descargar Excel'
                )}
              </Button>
            </Grid>
          </Grid>
        </CardContent>
        {exporting && <LinearProgress />}
      </Card>

      {/* Tabla de demandas con paginación */}
      <Card sx={{ boxShadow: 3 }}>
        <CardContent sx={{ p: 0 }}>
          <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
            <Table stickyHeader size="medium">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>ID</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>N° Demanda</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Demandante</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Procurador</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Estado</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Tipo Demanda</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Naturaleza</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Monto Estimación</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Fecha Creación</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {demandasPaginadas.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ py: 6 }}>
                      <Box sx={{ textAlign: 'center', color: 'text.secondary' }}>
                        <FilterIcon sx={{ fontSize: 48, mb: 2, opacity: 0.5 }} />
                        <Typography variant="h6" gutterBottom>
                          No se encontraron demandas
                        </Typography>
                        <Typography variant="body2">
                          {demandas.length === 0 
                            ? 'No hay datos disponibles' 
                            : 'Intente ajustar los filtros de búsqueda'
                          }
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  demandasPaginadas.map((demanda) => {
                    const infoProcurador = getInfoProcurador(demanda.usuarioprocuradorid);
                    
                    return (
                      <TableRow key={demanda.tramiteid} hover>
                        <TableCell component="th" scope="row">
                          <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 'bold' }}>
                            #{demanda.tramiteid}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                            {demanda.numerodemanda || 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                            {demanda.nombredemandante || 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {getInfoProcurador(demanda.procuradorasignado).nombre}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={demanda.estado || 'N/A'} 
                            color={getColorEstado(demanda.estado)}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {getTextoMapeado(demanda.tipodemanda, 'tipoDemanda')}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {getTextoMapeado(demanda.naturaleza, 'naturaleza')}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 'bold' }}>
                            {formatearMoneda(demanda.montoestimacion)}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                            {formatearFecha(demanda.fechacreacion)}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Tooltip title="Ver detalles">
                            <IconButton 
                              size="small" 
                              onClick={() => verDetalles(demanda)}
                              color="primary"
                            >
                              <Visibility />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
          
          {/* Paginación */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={filteredDemandas.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Filas por página:"
            labelDisplayedRows={({ from, to, count }) => 
              `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
            }
          />
        </CardContent>
      </Card>

      {/* Dialog de filtros */}
      <Dialog open={dialogFiltros} onClose={() => setDialogFiltros(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
          <FilterIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
          Filtros de Demandas Legales
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1, p: 1 }}>
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom color="primary">
                Rango de Fechas
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Fecha Inicio"
                    type="date"
                    fullWidth
                    value={filtros.fechaInicio}
                    onChange={(e) => setFiltros({ ...filtros, fechaInicio: e.target.value })}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Fecha Fin"
                    type="date"
                    fullWidth
                    value={filtros.fechaFin}
                    onChange={(e) => setFiltros({ ...filtros, fechaFin: e.target.value })}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                  />
                </Grid>
              </Grid>
            </Grid>
            
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom color="primary">
                Filtros Adicionales
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Procurador</InputLabel>
                    <Select
                      value={filtros.procurador}
                      label="Procurador"
                      onChange={(e) => setFiltros({ ...filtros, procurador: e.target.value })}
                    >
                      <MenuItem value="">Todos los procuradores</MenuItem>
                      {procuradoresUnicos.map(procurador => (
                        <MenuItem key={procurador.id} value={procurador.id.toString()}>
                          {procurador.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Estado</InputLabel>
                    <Select
                      value={filtros.estado}
                      label="Estado"
                      onChange={(e) => setFiltros({ ...filtros, estado: e.target.value })}
                    >
                      <MenuItem value="">Todos</MenuItem>
                      {estadosUnicos.map(estado => (
                        <MenuItem key={estado} value={estado}>
                          {estado}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Tipo Demanda</InputLabel>
                    <Select
                      value={filtros.tipoDemanda}
                      label="Tipo Demanda"
                      onChange={(e) => setFiltros({ ...filtros, tipoDemanda: e.target.value })}
                    >
                      <MenuItem value="">Todos</MenuItem>
                      {tiposDemandaUnicos.map(tipo => (
                        <MenuItem key={tipo} value={tipo.toString()}>
                          {getTextoMapeado(tipo, 'tipoDemanda')}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Juzgado</InputLabel>
                    <Select
                      value={filtros.juzgado}
                      label="Juzgado"
                      onChange={(e) => setFiltros({ ...filtros, juzgado: e.target.value })}
                    >
                      <MenuItem value="">Todos</MenuItem>
                      {juzgadosUnicos.map(juzgado => (
                        <MenuItem key={juzgado} value={juzgado.toString()}>
                          {getTextoMapeado(juzgado, 'juzgado')}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Naturaleza</InputLabel>
                    <Select
                      value={filtros.naturaleza}
                      label="Naturaleza"
                      onChange={(e) => setFiltros({ ...filtros, naturaleza: e.target.value })}
                    >
                      <MenuItem value="">Todas</MenuItem>
                      {naturalezasUnicas.map(naturaleza => (
                        <MenuItem key={naturaleza} value={naturaleza.toString()}>
                          {getTextoMapeado(naturaleza, 'naturaleza')}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Tipo Demandante</InputLabel>
                    <Select
                      value={filtros.tipoDemandante}
                      label="Tipo Demandante"
                      onChange={(e) => setFiltros({ ...filtros, tipoDemandante: e.target.value })}
                    >
                      <MenuItem value="">Todos</MenuItem>
                      {tiposDemandanteUnicos.map(tipo => (
                        <MenuItem key={tipo} value={tipo.toString()}>
                          {getTextoMapeado(tipo, 'tipoDemandante')}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={limpiarFiltros} startIcon={<ClearIcon />} color="error">
            Limpiar Filtros
          </Button>
          <Button onClick={aplicarFiltros} variant="contained" sx={{ minWidth: 120 }}>
            Aplicar Filtros
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ReporteriaDemandasLegales;